"use client";

import { globalStyleObj } from "@/app/assets/styles";
import { LabelText } from "@/components";
import { Input } from "@/components/ui/input";
import { MdAdd, MdClose } from "react-icons/md";

const RepeatableTextTextTextInput = ({
  formData = {},
  labelText = "",
  fieldId = "",
  lableStatus = false,
  translateField = false,
  repeatableKeyname = "",
  repeatableKeys = [],
  addNewField = () => {},
  removeField = () => {},
  onChangeField = () => {},
  placeHolderText = "",
  extraContainerClasses = "",
  inputBoxMaxWidth = "lg:max-w-[800px]",
}) => {
  return (
    <div
      className={`${globalStyleObj.commonInputContainerClass} ${extraContainerClasses}`}
    >
      <LabelText
        text={labelText}
        htmlForId={fieldId}
        star={lableStatus}
        translateField={translateField}
      />

      <div className={`w-full ${inputBoxMaxWidth}`}>
        {formData?.[repeatableKeyname] &&
          formData?.[repeatableKeyname]?.[repeatableKeys[0]]?.length > 0 && (
            <ul className="w-full flex flex-col border border-dashed border-[#000]/20 dark:border-[#fff]/10 rounded-md">
              {formData[repeatableKeyname][repeatableKeys[0]].map(
                (eachItem, index) => (
                  <li
                    key={`options-card-${index + 1}`}
                    className="flex gap-1 px-4 py-3"
                  >
                    <div className="flex flex-col gap-3 w-full">
                      {/* Text Field 1 */}
                      <Input
                        type="text"
                        name={repeatableKeys[0]}
                        value={
                          formData?.[repeatableKeyname]?.[
                            repeatableKeys?.[0]
                          ]?.[index] || ""
                        }
                        onChange={(e) =>
                          onChangeField(
                            repeatableKeyname,
                            repeatableKeys[0],
                            e.target.value,
                            index
                          )
                        }
                        placeholder={`${placeHolderText} ${index + 1}`}
                        className="w-full border border-[#000]/20 font-poppins-rg text-[13px] text-light-weight-400 focus-visible:outline-none focus-visible:ring-0 dark:border-[#fff]/10 dark:bg-[#000]/10 dark:text-light-weight-400"
                      />

                      {/* Text Field 2 */}
                      <Input
                        type="text"
                        name={repeatableKeys[1]}
                        value={
                          formData?.[repeatableKeyname]?.[
                            repeatableKeys?.[1]
                          ]?.[index] || ""
                        }
                        onChange={(e) =>
                          onChangeField(
                            repeatableKeyname,
                            repeatableKeys[1],
                            e.target.value,
                            index
                          )
                        }
                        placeholder={`${placeHolderText} ${index + 1}`}
                        className="w-full border border-[#000]/20 font-poppins-rg text-[13px] text-light-weight-400 focus-visible:outline-none focus-visible:ring-0 dark:border-[#fff]/10 dark:bg-[#000]/10 dark:text-light-weight-400"
                      />

                      {/* Text Field 3 */}
                      <Input
                        type="text"
                        name={repeatableKeys[2]}
                        value={
                          formData?.[repeatableKeyname]?.[
                            repeatableKeys?.[2]
                          ]?.[index] || ""
                        }
                        onChange={(e) =>
                          onChangeField(
                            repeatableKeyname,
                            repeatableKeys[2],
                            e.target.value,
                            index
                          )
                        }
                        placeholder={`${placeHolderText} ${index + 1}`}
                        className="w-full border border-[#000]/20 font-poppins-rg text-[13px] text-light-weight-400 focus-visible:outline-none focus-visible:ring-0 dark:border-[#fff]/10 dark:bg-[#000]/10 dark:text-light-weight-400"
                      />
                    </div>

                    <button
                      type="button"
                      onClick={() =>
                        removeField(repeatableKeyname, repeatableKeys, index)
                      }
                      className="size-[30px] flex items-center justify-center"
                    >
                      <MdClose size={20} color="red" />
                    </button>
                  </li>
                )
              )}
            </ul>
          )}
        <button
          type="button"
          onClick={() => addNewField(repeatableKeyname, repeatableKeys)}
          className={`w-full max-w-[400px] py-2 rounded-md bg-green-500/10 hover:bg-green-500 text-green-500 hover:text-white transition-300 text-[14px] font-poppins-rg flex justify-center items-center gap-2 ${formData?.[repeatableKeyname]?.[repeatableKeys[0]]?.length > 0 ? "mt-4 mx-auto" : ""}`}
        >
          <MdAdd size={20} />
          <span>Add New</span>
        </button>
      </div>
    </div>
  );
};

export default RepeatableTextTextTextInput;
